export const CONTENT_TYPE = {
    VIDEO: 1, //  (Would have video url as content)
    IMAGE: 2, //  (Would have image url as content)
    HTML: 3, //  (Would have html string as content)
    DOWNLOAD: 4, //  Item (Would have attachment download link as content)
    HYPERLINK: 5, //  Iteem (Would have link as content)
    PDF: 6,
    EMBED: 7, // Item would have iframe of SpeedExam as content
    EXAM: 8,
    FORM: 9,
    LIVE_SESSION: 10, // Item would have iframe of SpeedExam as content
    PROGRESS_TRACKING_FORM: 11,
};
